import { motion } from "framer-motion";
import SEO from "@/components/SEO";
import StaticBackdrop from "@/components/StaticBackdrop";
import SiteNav from "@/components/SiteNav";
import SiteFooter from "@/components/SiteFooter";
import FinalCTA from "@/components/FinalCTA";
import { PAGE_ANIMATE, PAGE_INITIAL, PAGE_TRANSITION } from "@/components/shared/motion";

export default function PageShell({
  children,
  seo,
  finalCtaFrom = "page",
  showFinalCta = true,
  testId,
}) {
  return (
    <div className="relative min-h-screen" data-testid={testId}>
      <SEO {...seo} />
      <StaticBackdrop />
      <SiteNav />
      <motion.main
        className="relative z-10"
        initial={PAGE_INITIAL}
        animate={PAGE_ANIMATE}
        transition={PAGE_TRANSITION}
      >
        {children}
        {showFinalCta && <FinalCTA from={finalCtaFrom} />}
      </motion.main>
      <SiteFooter />
    </div>
  );
}
